export const Language = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1_5860)">
  <path d="M4.84734 14H2.35927L6.15036 3.01818H9.14247L12.9282 14H10.4401L7.68931 5.5277H7.60352L4.84734 14ZM4.69183 9.68342H10.5688V11.4958H4.69183V9.68342Z" fill="currentColor"/>
  <path d="M11.2275 21.1108L13.0451 21.6362C11.2559 26.7482 7.94734 29.7302 2.86374 31.3206C2.66494 30.8946 2.12534 30.071 1.78454 29.6592C6.69774 28.367 9.75074 25.74 11.2275 21.1108ZM5.74634 21.2244C7.18054 25.4276 10.2477 28.4522 15.3029 29.5882C14.8911 29.9858 14.3373 30.7952 14.0675 31.2922C8.74254 29.9006 5.81734 26.6488 4.04234 21.7356L5.74634 21.2244ZM2.04014 20.1878H15.0473V21.8634H2.04014V20.1878ZM7.62074 17.9442H9.38154V21.2102H7.62074V17.9442Z" fill="currentColor"/>
  <path d="M18 13H30" stroke="currentColor" stroke-width="2"/>
  <path d="M18 17H30" stroke="currentColor" stroke-width="2"/>
  <path d="M18 21H24" stroke="currentColor" stroke-width="2"/>
  </g>
  <defs>
  <clipPath id="clip0_1_5860">
  <rect width="32" height="32" fill="white"/>
  </clipPath>
  </defs>
</svg>`;
